import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-route-modify',
  templateUrl: './route-modify.component.html',
  styleUrls: ['./route-modify.component.css']
})
export class RouteModifyComponent implements OnInit {

  form: any | FormGroup
  RouteData:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleParam:any = []
  singleRoute: any = [];
  routeid: any = "";
  cid:any
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllRoute()
    this.form = this.fb.group({
      routeName: [''],
      // routeDetailResponses:this.fb.array([])
    }) 
    // this.addrouteDetailResponses()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllRoute();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllRoute();
  }


  // get routeArr(){
  //   return this.form.get('routeDetailResponses') as FormArray;
  // }

  // routeDetailResponses(){
  //   return this.fb.group({
  //     "currentLatitude": [''],
  //     "currentLongitude": [''],
  //     "captureDateTime": new Date().getTime(),
  //     "status": true
  //   })
  // }
  // addrouteDetailResponses(){
  //   this.routeArr.push(this.routeDetailResponses())
  //   }
  
  // removerouteDetailResponses(index: number){
  //   this.routeArr.removeAt(index)
  // }

  updateRoute(){
      let body = {
          "id":this.routeid,
          "version": 0,
          "isActive": true,
          "description": "string",
          "routeName": String(this.form.get('routeName').value),
          "routeStatus": "Active",
          "cid": this.cid
        }

    console.log(body)
    this.generic_service.updateRoute(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllRoute()
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllRoute(){
    this.generic_service.getAllRoute().subscribe(
      (res:any)=> {
        console.log(res)
        this.RouteData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getRouteById(id:any){
    this.routeid = id
    this.generic_service.getRouteById(id).subscribe(
      (response:any)=>{
        this.singleRoute = []
        this.singleRoute.push(response.response)
        console.log(this.singleRoute)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }
}